
import { Service_GetBranchRelId } from '@/service/branch_relId_service'
import { COU_Sleep } from '@/utils/co_util'
import { COU_httpGet, COU_httpPost } from '@/utils/http'

// 1688精选货源筛选项 (1688筛选条件接口)
async function GetProductFilter() {
  var url = `/ali/productFilter?branchRelId=${Service_GetBranchRelId()}`
  const r = await COU_httpGet({ url  })
  let list = [], success = false, msg = ''
  try {
    success = r.success
    list = r.result
    msg = r.msg
  }
  catch(error) {
    console.log(error)
  }
  list = list || []
  return { list, success, msg }
}

// 获取1688商品池选项列表
async function GetPoolList() {
  var url = `/ali/productTagList?branchRelId=${Service_GetBranchRelId()}`
  const r = await COU_httpGet({ url })
  let pools = []
  try {
    pools = r.result
  }
  catch(error) {
    console.log(error)
  }
  pools = pools?.length ? pools.filter(item => ![508287, 508288, 508289].includes(item.ruleId)) : []
  return { pools }
}

// 1688搜词
async function SearchGoodsByKeyword(data) {
  const params = {
    branchRelId: Service_GetBranchRelId(),
    page: data.page, size: data.size,
    categoryId: data.catId?.length ? data.catId[data.catId.length - 1] : '', 
    keyword: data.keyword, ruleIds: data.poolId,
    filters: data.filters || ''
  }

  const r = await COU_httpGet({ url: `ali/productList`, data: params })
  let list = [], msg = '', success = false, info = '', total = 0
  try {
    success = r.success
    msg = r.msg
    if (!success && msg?.includes('授权')) {
      // msg = '目前需要先授权【1688】，才能正常使用【1688】选品铺货等功能'
      info = r.result
    }
    list = r.result.Datas
    total = r.result.TotalNum
  } 
  catch (error) {
    console.log(error)
  }
  if (!list?.length) {
    list = []
    // 如果第一次没有获取到数据，那就再请求一次
    if (!data.isLastGetApi) {
      data.isLastGetApi = true
      await COU_Sleep(800)
      return SearchGoodsByKeyword(data)
    }
  }
  list = list || []
  return { list, msg, success, info, total }
}

// 获取1688类目列表
async function GetCategoryList({ parentId = 0 }) {
  const r = await COU_httpGet({ url: `/util/aliCategoryList`, data: { parentCatId: parentId, size: 100 } })
  let list = [], success = false, msg = ''
  try {
    success = r.success
    list = r.result.Datas
    msg = r.msg
  }
  catch(error) {
    console.log(error)
  }
  list = list || []
  return { list, success, msg }
}

// 1688甄选货盘, 1688福利品货盘, 小贵子供应链货盘 
async function RequestData({ url, data }) {
  const params = {
    title: data.keyword,
    order_by: data.sort,
    ...data,
    firstCid: data.catId
  }
  const r = await COU_httpPost({ url: `/ali/${url}`, data: params })
  let list = [], msg = '', success = false, info = '', total = 0
  try {
    success = r.success
    msg = r.msg
    if (!success && msg?.includes('授权')) {
      msg = '目前需要先授权【1688】，才能正常使用【1688】】选品铺货等功能'
      info = r.result
    }
    list = r.result.Datas
    total = r.result.TotalNum
  } 
  catch (error) {
    console.log(error)
  }
  list = list || []
  return { list, msg, success, info, total }
}

// 1688搜图
async function SearchGoodsByImage(data) {
  data.branchRelId = Service_GetBranchRelId()
  const url = `/ali/imageSearchItemList`
  const r = await COU_httpPost({ url, data })
  let list = [], total = 0, msg = '', success = false, info = {}
  try {
    msg = r.msg
    success = r.success
    if (!success) info = r.result
    else list = r.result
  } 
  catch (error) {
    console.log(error)
  }
  list = list || []
  total = list.length
  return { list, total, msg, success, info  }
}

export default { GetProductFilter, GetPoolList, SearchGoodsByKeyword, GetCategoryList, RequestData, SearchGoodsByImage }